module.exports = __webpack_public_path__ + "dist/introduce_3.94d0206d.png";